import React, { useEffect, useState } from "react";
import { CreacionPaletizacionApi } from "../api/CreacionPaletizacionApi";
import { NotificationManager } from "react-notifications";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";
import { useForm } from "react-hook-form";
import moment from "moment";
import { ESTADOS_PRODUCCION } from "../../../../../../../../../utility/constants";
import { ProduccionV2Api } from "../../../../../api/ProduccionV2Api";

export const usePaletizacionForm = (idPaletizacion, regresar) => {
    const {
        getMetricasPaletizacion,
        crearPallet,
        eliminarPallet,
        actualizarEstadoConformePallet,
        getSiguienteNumeroPallet,
        enviarABodega,

        cargando: cargandoCreacionPaletizacion,
    } = CreacionPaletizacionApi();

    const {
        getDetallePaletizacion,

        cargando: cargandoDetallePaletizacion,
    } = ProduccionV2Api();

    const [siguienteNumeroPallet, setSiguienteNumeroPallet] = useState("");
    const [pallets, setPallets] = useState([]);
    const [metricasPaletizacion, setMetricasPaletizacion] = useState({});

    const [reclasificacionRefreshKey, setReclasificacionRefreshKey] =
        useState(0);

    const GetSiguienteNumeroPallet = async () => {
        try {
            const numero = await getSiguienteNumeroPallet();
            setSiguienteNumeroPallet(numero);
        } catch (error) {
            console.error(
                "Error al obtener el siguiente número de paletización:",
                error,
            );
            setSiguienteNumeroPallet("ERROR AL OBTENER NÚMERO");
        }
    };

    const GetDetallePaletizacion = async () => {
        try {
            const response =
                (await getDetallePaletizacion(idPaletizacion)) || {};
            setPallets(response.pallets || []);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener los pallets de la paletización",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setPallets([]);
        }
    };

    const GetMetricasPaletizacion = async () => {
        try {
            const response = await getMetricasPaletizacion(idPaletizacion);
            setMetricasPaletizacion(response || {});
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las métricas de paletización",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setMetricasPaletizacion({});
        }
    };

    const RefreshData = () => {
        GetMetricasPaletizacion();
        GetSiguienteNumeroPallet();
        GetDetallePaletizacion();
        // refresca la disponibilidad de reclasificación/sobrante en los modales,
        // necesario sobre todo al eliminar un pallet (donde el producto
        // seleccionado no cambia y no se dispararía el refetch por sí solo)
        setReclasificacionRefreshKey((prev) => prev + 1);
    };

    useEffect(() => {
        if (idPaletizacion) RefreshData();
    }, [idPaletizacion]);

    const CrearPallet = async (data) => {
        try {
            await crearPallet(idPaletizacion, data);
            NotificationManager.success(
                "Pallet creado con éxito",
                "Éxito",
                3000,
            );
            RefreshData();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al crear el pallet",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            throw error;
        }
    };

    const EliminarPallet = async (idPallet) => {
        try {
            await eliminarPallet(idPallet);

            NotificationManager.success(
                "Pallet eliminado con éxito",
                "Éxito",
                3000,
            );
            RefreshData();
        } catch (error) {
            console.log("Error al eliminar pallet:", error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar el pallet",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const ActualizarEstadoConformePallet = async (
        idPallet,
        conforme,
        tarjetaSalida,
    ) => {
        try {
            await actualizarEstadoConformePallet(
                idPallet,
                conforme,
                tarjetaSalida,
            );
            RefreshData();
        } catch (error) {
            console.log(
                "Error al actualizar estado conforme del pallet:",
                error,
            );
            const errorMsg = getErrorFromResponse(
                error,
                "Error al actualizar el estado conforme del pallet",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const EnviarABodega = async () => {
        try {
            // si no hay pallets, mostrar advertencia
            if (pallets.length === 0) {
                NotificationManager.warning(
                    "Debe agregar al menos un pallet",
                    "Advertencia",
                    3000,
                );
                return;
            }

            await enviarABodega(idPaletizacion);

            NotificationManager.success(
                "Paletización enviada con éxito",
                "Éxito",
                3000,
            );

            regresar();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al enviar la paletización",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    return {
        siguienteNumeroPallet,
        pallets,
        setPallets,
        CrearPallet,
        EliminarPallet,
        ActualizarEstadoConformePallet,
        EnviarABodega,
        reclasificacionRefreshKey,

        metricasPaletizacion,

        cargando: cargandoCreacionPaletizacion || cargandoDetallePaletizacion,
    };
};
